import React from "react";
import { ClockClockwise } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/api";

/** Chronological workflow / audit timeline for a single job. */
export function JobWorkflowCard({ audit = [] }) {
  return (
    <div className="rmms-card p-5">
      <div className="overline mb-3 flex items-center gap-1"><ClockClockwise size={11} /> Workflow</div>
      <ol className="space-y-3 relative">
        {audit.map((a) => (
          <li key={a.id || `${a.at}-${a.action}`} data-testid={`audit-${a.action}`} className="pl-5 relative">
            <span className="absolute left-0 top-1.5 h-2 w-2 rounded-full" style={{ background: a.action === "sla_breached" ? "#E11D48" : "#002FA7" }} />
            <div className="text-sm font-medium capitalize">{a.action.replace(/_/g, " ")}</div>
            <div className="text-[11px] text-slate-500 font-mono-data">{fmtDate(a.at)}</div>
          </li>
        ))}
        {audit.length === 0 && <li className="text-sm text-slate-400">No history yet.</li>}
      </ol>
    </div>
  );
}
